import React, { useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { LanguageCode } from '../utils/translations';

const Header: React.FC = () => {
  const { currentLanguage, setLanguage, t } = useLanguage();
  const [showLanguageMenu, setShowLanguageMenu] = useState(false);

  const languages: { code: LanguageCode; name: string; flag: string; label: string }[] = [
    { code: 'pl', name: 'Polski', flag: '🇵🇱', label: 'PL' },
    { code: 'en', name: 'English', flag: '🇬🇧', label: 'EN' },
    { code: 'de', name: 'Deutsch', flag: '🇩🇪', label: 'DE' },
    { code: 'es', name: 'Español', flag: '🇪🇸', label: 'ES' },
    { code: 'fr', name: 'Français', flag: '🇫🇷', label: 'FR' },
    { code: 'it', name: 'Italiano', flag: '🇮🇹', label: 'IT' },
    { code: 'fi', name: 'Suomi', flag: '🇫🇮', label: 'FI' },
    { code: 'lv', name: 'Latviešu', flag: '🇱🇻', label: 'LV' },
    { code: 'et', name: 'Eesti', flag: '🇪🇪', label: 'ET' },
    { code: 'lt', name: 'Lietuvių', flag: '🇱🇹', label: 'LT' },
    { code: 'sk', name: 'Slovenčina', flag: '🇸🇰', label: 'SK' },
    { code: 'ua', name: 'Українська', flag: '🇺🇦', label: 'UA' },
  ];

  const currentLang = languages.find(lang => lang.code === currentLanguage);

  return (
    <header className="header">
      <div className="logo">
        <a href="https://buglo.pl">
            <img src="/logo.svg" alt="Buglo logo" className="logo-icon" />
        </a>
      </div>
      <div className="language-selector" style={{ position: 'relative' }}>
        <div 
          onClick={() => setShowLanguageMenu(!showLanguageMenu)}
          style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px' }}
        >
          {/* <span>{currentLang?.flag}</span> */}
          <span style={{fontWeight: '700', display: 'inline-block'}}>{t('language')}</span>
          <span style={{ fontSize: '12px', color: '#F44603' }}><svg width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1.75671 1.7527C4.84966 1.7527 7.35742 5.10776 7.35742 9.24683" stroke="#F44603" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
                <path d="M13 1.7527C9.90672 1.7527 7.39929 5.10776 7.39929 9.24683" stroke="#F44603" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg></span>
        </div>
        
        {showLanguageMenu && (
          <div style={{
            position: 'absolute',
            top: '100%',
            right: 0,
            backgroundColor: '#E8F0F3',
            borderRadius: '8px',
            minWidth: '120px',
            zIndex: 1000,
            boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
            overflow: 'hidden',
          }}>
            {languages.map((lang) => (
              <div
                key={lang.code}
                onClick={() => {
                  setLanguage(lang.code);
                  setShowLanguageMenu(false);
                }}
                style={{
                  padding: '8px 16px',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  color: lang.code === currentLanguage ? '#F44603' : '#000',
                  transition: 'background-color 0.2s, color 0.2s',
                }}
                onMouseOver={(e) => {
                  if (lang.code !== currentLanguage) {
                    e.currentTarget.style.color = '#000000';
                  }
                }}
                onMouseOut={(e) => {
                  if (lang.code !== currentLanguage) {
                    e.currentTarget.style.color = '#000000';
                  }
                }}
              >
                <span style={{textTransform: 'uppercase', fontWeight: '700', lineHeight: '1'}}>{lang.label}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
